import { put } from "redux-saga/effects";
import { actions } from "../../actions";
import {
  fetchUserPassengers,
  IListUserPassengersResponse,
} from "../../../../api/v0/book/user-passengers/fetchUserPassengers";
import { CallState } from "redmond";

export function* fetchUserPassengersSaga(_: actions.IFetchUserPassengers) {
  try {
    const userPassengers: IListUserPassengersResponse =
      yield fetchUserPassengers({});

    yield put(
      actions.setUserPassengers({
        userPassengerCallState: CallState.Success,
        userPassengers: userPassengers,
      })
    );
  } catch (e) {
    yield put(actions.setUserPassengersCallStateFailed());
  }
}
